import {Types} from "../../../../type/Types";

export type PlaceKeywordValueObject = {
    id: bigint
    placeId: bigint
    rank: number | null
    keyword: string
    createdAt: Date
    modifiedAt: Date | null
    crawlerHandledAt: Date | null
    deletedAt: Date | null
}

export namespace PlaceKeywordValueObject {
    export function construct(o: any): PlaceKeywordValueObject {
        return {
            id: BigInt(o.id),
            placeId: BigInt(o.placeId),
            rank: Types.asNull(o.rank, Number),
            keyword: String(o.keyword),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            crawlerHandledAt: Types.asNull(o.crawlerHandledAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o))
        }
    }

    export const description: Record<keyof PlaceKeywordValueObject, string> = {
        id: 'ID',
        placeId: '플레이스 ID',
        rank: '순위',
        keyword: '키워드',
        createdAt: '생성 일자',
        modifiedAt: '수정 일자',
        crawlerHandledAt: '크롤러 응답 데이터 마지막 핸들 일자',
        deletedAt: '삭제 일자'
    }
}